// HeroSlider.jsx
import React, { useRef , useState } from 'react';
// import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import SignUpForm from "./SignUpForm";

import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

const heroSlides = [
  {
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80',
    alt: 'Digital technology and innovation',
  },
  {
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80',
    alt: 'Team collaboration',
  },
  {
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&q=80',
    alt: 'Web development and coding',
  },
  {
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80',
    alt: 'Business success',
  },
];

const HeroSlider = () => {
  const swiperRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
    const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <section
      className="hero-section cursor-pointer relative"
      onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
      onMouseLeave={() => swiperRef.current?.autoplay?.start()}
    >
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={1000}
        pagination={{ clickable: true }}
        className="!overflow-hidden"
      >
        {heroSlides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative min-h-[280px] h-[380px] sm:h-[420px] md:h-[500px] w-full">
              <img
                src={slide.image}
                alt={slide.alt}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/50" />
              <div className="absolute inset-0 flex flex-col items-center justify-center z-10 text-white text-center px-4 py-6">
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-2 leading-tight">Welcome to Wicuna Technologies</h2>
                <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-blue-100 mb-4 md:mb-6 max-w-xl">Your One-Stop Solution for Digital Success</p>
                  <button 
                    onClick={() => {
                    closeMobileMenu();
                    setShowModal(true);
                  }}
                  className="px-6 py-2.5 sm:px-8 sm:py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold text-sm sm:text-base transition-colors inline-block">
                  Get A Quote
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}

         {showModal && <SignUpForm closeModal={() => setShowModal(false)} />}
      </Swiper>
    </section>
  );
};

export default HeroSlider;
